"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActions = void 0;
const react_1 = require("react");
const useActions = (actions, state, dispatch) => {
    const getState = (0, react_1.useCallback)(() => state, [state]);
    return Object.keys(actions).reduce((result, actionName) => {
        const action = actions[actionName];
        result[actionName] = (...args) => {
            const performedAction = action(...args);
            if (typeof performedAction === 'function') {
                return performedAction(getState, dispatch);
            }
            return dispatch(performedAction);
        };
        return result;
    }, {});
};
exports.useActions = useActions;
//# sourceMappingURL=index.js.map